export function appRedirect(app) {
  const ua = navigator.userAgent || navigator.vendor || window.opera;

  if (/android/i.test(ua)) {
    window.location.href = app.android;
  } else if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
    window.location.href = app.ios;
  } else {
    window.location.href = app.fallback;
  }
}
